module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-label"
  }, [_vm._v(_vm._s(_vm.labels[_vm.paramName]) + ": "), _vm._t("default"), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.remove
    }
  }, [_c('icon', {
    attrs: {
      "name": "times"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e2080f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search-results/FilterLabelComponent.vue
// module id = 1446
// module chunks = 1